// 로컬: /public 경로로 테스트
// 운영(impink.co.kr): 루트 경로 /
const hostname = window.location.hostname;
export const PUBLIC_BASE =
  hostname === 'impink.co.kr' || hostname === 'www.impink.co.kr' ||
  hostname === 'urpink.co.kr' || hostname === 'www.urpink.co.kr' ||
  hostname === 'localhost' || hostname === '100.68.115.13' || hostname === '100.116.73.97' ? '' : '/public';
